<div class="customer-survey-container">
  
  <!-- Header -->
  <div class="page-header">
    <h2>
      <button class="btn btn-secondary btn-sm mr-3" (click)="goBack()">
        <i class="fas fa-arrow-left"></i> Back
      </button>
      Create New Survey
    </h2>
  </div>

  <!-- Alert Messages -->
  <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
    <button type="button" class="close" (click)="successMessage = ''">
      <span>&times;</span>
    </button>
  </div>

  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
    <button type="button" class="close" (click)="errorMessage = ''">
      <span>&times;</span>
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <p class="mt-2">Loading data...</p>
  </div>

  <!-- Create Survey Form -->
  <div *ngIf="!loading" class="create-view">
    <form [formGroup]="surveyForm" (ngSubmit)="createSurvey()">
      
      <!-- Survey Details Card -->
      <div class="card mb-4">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="fas fa-info-circle"></i> Survey Details</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Survey Title <span class="text-danger">*</span></label>
                <input type="text" 
                       formControlName="survey_title" 
                       class="form-control"
                       placeholder="Enter survey title (e.g., Q1 2026 Customer Satisfaction Survey)">
                <div class="text-danger small mt-1" 
                     *ngIf="surveyForm.get('survey_title')?.invalid && surveyForm.get('survey_title')?.touched">
                  Survey title is required
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Description</label>
                <textarea formControlName="survey_description" 
                          class="form-control" 
                          rows="3"
                          placeholder="Enter survey description"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Questionnaire Sets -->
      <div class="card mb-4">
        <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
          <h5 class="mb-0"><i class="fas fa-list-alt"></i> Questionnaire Sets</h5>
          <button type="button" class="btn btn-light btn-sm" (click)="addQuestionnaireSet()">
            <i class="fas fa-plus"></i> Add Set
          </button>
        </div>
        <div class="card-body">
          <div formArrayName="questionnaire_sets">
            <div *ngFor="let setGroup of questionnaireSets.controls; let setIndex = index" 
                 [formGroupName]="setIndex" 
                 class="questionnaire-set mb-4 p-3 border rounded">
              
              <!-- Set Header -->
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0 text-success">
                  <i class="fas fa-folder"></i> Set {{ setIndex + 1 }}
                </h6>
                <button type="button" 
                        class="btn btn-danger btn-sm" 
                        (click)="removeQuestionnaireSet(setIndex)"
                        [disabled]="questionnaireSets.length === 1">
                  <i class="fas fa-trash"></i> Remove Set
                </button>
              </div>

              <!-- Set Details -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Set ID <span class="text-danger">*</span></label>
                    <input type="text" 
                           formControlName="set_id" 
                           class="form-control"
                           placeholder="e.g., Wood_Products">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Set Name <span class="text-danger">*</span></label>
                    <input type="text" 
                           formControlName="set_name" 
                           class="form-control"
                           placeholder="e.g., Wood Product Quality Assessment">
                  </div>
                </div>
              </div>

              <!-- Questions -->
              <div formArrayName="questions" class="ml-3">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="mb-0"><strong>Questions</strong></label>
                  <button type="button" 
                          class="btn btn-info btn-sm" 
                          (click)="addQuestion(setIndex)">
                    <i class="fas fa-plus"></i> Add Question
                  </button>
                </div>

                <div *ngFor="let questionGroup of getQuestions(setIndex).controls; let qIndex = index" 
                     [formGroupName]="qIndex" 
                     class="question-item mb-3 p-3 bg-light border rounded">
                  
                  <!-- Question Header -->
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <strong class="text-info">Question {{ qIndex + 1 }}</strong>
                    <button type="button" 
                            class="btn btn-danger btn-sm" 
                            (click)="removeQuestion(setIndex, qIndex)"
                            [disabled]="getQuestions(setIndex).length === 1">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>

                  <!-- Question Details -->
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Question ID <span class="text-danger">*</span></label>
                        <input type="text" 
                               formControlName="question_id" 
                               class="form-control form-control-sm"
                               placeholder="e.g., Q1">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Type <span class="text-danger">*</span></label>
                        <select formControlName="question_type" 
                                class="form-control form-control-sm"
                                (change)="onQuestionTypeChange(setIndex, qIndex, $any($event.target).value)">
                          <option *ngFor="let type of questionTypes" [value]="type.value">
                            {{ type.label }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Required?</label>
                        <div class="custom-control custom-checkbox mt-2">
                          <input type="checkbox" 
                                 formControlName="is_required" 
                                 class="custom-control-input" 
                                 [id]="'required-' + setIndex + '-' + qIndex">
                          <label class="custom-control-label" 
                                 [for]="'required-' + setIndex + '-' + qIndex">
                            Required
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Question Text <span class="text-danger">*</span></label>
                        <textarea formControlName="question_text" 
                                  class="form-control form-control-sm" 
                                  rows="2"
                                  placeholder="Enter your question here"></textarea>
                      </div>
                    </div>
                  </div>

                  <!-- Options for Multiple Choice -->
                  <div *ngIf="questionGroup.get('question_type')?.value === 'multiple_choice'" 
                       formArrayName="options">
                    <label><strong>Options:</strong></label>
                    <div *ngFor="let option of getOptions(setIndex, qIndex).controls; let optIndex = index" 
                         class="input-group input-group-sm mb-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ optIndex + 1 }}</span>
                      </div>
                      <input type="text" 
                             [formControlName]="optIndex" 
                             class="form-control"
                             placeholder="Enter option">
                      <div class="input-group-append">
                        <button type="button" 
                                class="btn btn-danger" 
                                (click)="removeOption(setIndex, qIndex, optIndex)"
                                [disabled]="getOptions(setIndex, qIndex).length <= 1">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <button type="button" 
                            class="btn btn-success btn-sm" 
                            (click)="addOption(setIndex, qIndex)">
                      <i class="fas fa-plus"></i> Add Option
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Assignments -->
      <div class="card mb-4">
        <div class="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
          <h5 class="mb-0"><i class="fas fa-users"></i> Customer Assignments</h5>
          <button type="button" class="btn btn-dark btn-sm" (click)="addCustomerAssignment()">
            <i class="fas fa-plus"></i> Add Customer
          </button>
        </div>
        <div class="card-body">
          <div formArrayName="assigned_customers">
            <div *ngIf="assignedCustomers.length === 0" class="alert alert-info">
              No customers assigned yet. Click "Add Customer" to assign customers to employees.
            </div>

            <div class="table-responsive" *ngIf="assignedCustomers.length > 0">
              <table class="table table-bordered table-hover">
                <thead class="thead-light">
                  <tr>
                    <th width="5%">#</th>
                    <th width="35%">Customer</th>
                    <th width="35%">Assigned To Employee</th>
                    <th width="10%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let customerGroup of assignedCustomers.controls; let i = index" 
                      [formGroupName]="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <select formControlName="customer_id" 
                              class="form-control form-control-sm"
                              (change)="onCustomerSelect(i, $event)">
                        <option value="">Select Customer</option>
                        <option *ngFor="let customer of customers" 
                                [value]="customer.customer_id">
                          {{ customer.customer_name }}
                        </option>
                      </select>
                      <input type="hidden" formControlName="customer_name">
                    </td>
                    <td>
                      <select formControlName="assigned_to_employee" 
                              class="form-control form-control-sm">
                        <option value="">Select Employee</option>
                        <option *ngFor="let employee of employees" 
                                [value]="employee.employee_id">
                          {{ employee.employee_name }}
                        </option>
                      </select>
                    </td>
                    <td class="text-center">
                      <button type="button" 
                              class="btn btn-danger btn-sm" 
                              (click)="removeCustomerAssignment(i)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="card">
        <div class="card-body">
          <div class="form-actions text-right">
            <button type="button" 
                    class="btn btn-secondary btn-lg mr-2 px-5" 
                    (click)="goBack()"
                    [disabled]="submitting">
              <i class="fas fa-times"></i> Cancel
            </button>
            <button type="submit" 
                    class="btn btn-primary btn-lg px-5" 
                    [disabled]="submitting || surveyForm.invalid">
              <span *ngIf="!submitting">
                <i class="fas fa-save"></i> Create Survey
              </span>
              <span *ngIf="submitting">
                <i class="fas fa-spinner fa-spin"></i> Creating...
              </span>
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>

</div>